export const PURCHASE = 'PURCHASE';
export const CHANGE_PLAN = 'CHANGE_PLAN';



// WEBPACK FOOTER //
// ./app/constants/checkoutTypes.js